export type PlatformRole = 'SUPER_ADMIN' | 'PLATFORM_ADMIN' | 'SUPPORT';

export type TenantRole =
  | 'INSTITUTION_ADMIN'
  | 'TEACHER'
  | 'STUDENT'
  | 'GUARDIAN'
  | 'SECRETARY'
  | 'FINANCE'
  | 'TRANSPORT_OPERATOR';

export type Role = PlatformRole | TenantRole;

export const PLATFORM_ROLES: readonly PlatformRole[] = [
  'SUPER_ADMIN',
  'PLATFORM_ADMIN',
  'SUPPORT',
] as const;

export const TENANT_ROLES: readonly TenantRole[] = [
  'INSTITUTION_ADMIN',
  'TEACHER',
  'STUDENT',
  'GUARDIAN',
  'SECRETARY',
  'FINANCE',
  'TRANSPORT_OPERATOR',
] as const;

export function isPlatformRole(role: Role): role is PlatformRole {
  return (PLATFORM_ROLES as readonly string[]).includes(role);
}

export function isTenantRole(role: Role): role is TenantRole {
  return (TENANT_ROLES as readonly string[]).includes(role);
}

export const ROLE_LABELS: Record<Role, string> = {
  SUPER_ADMIN: 'Super Admin',
  PLATFORM_ADMIN: 'Admin da plataforma',
  SUPPORT: 'Suporte',
  INSTITUTION_ADMIN: 'Admin institucional',
  TEACHER: 'Professor',
  STUDENT: 'Aluno',
  GUARDIAN: 'Responsável',
  SECRETARY: 'Secretaria',
  FINANCE: 'Financeiro',
  TRANSPORT_OPERATOR: 'Operador de transporte',
};

export const ALL_ROLES: readonly Role[] = [...PLATFORM_ROLES, ...TENANT_ROLES];
